/**
 * Operator validators - Operator/admin specific types
 */
import { Infer, v } from 'convex/values';

// ============================================================================
// Audit Actor Role
// ============================================================================

export const auditActorRoleValidator = v.union(
  v.literal('provider'),
  v.literal('substitute'),
  v.literal('operator'),
  v.literal('admin')
);

export type AuditActorRole = Infer<typeof auditActorRoleValidator>;

export const AUDIT_ACTOR_ROLES = ['provider', 'substitute', 'operator', 'admin'] as const;

// ============================================================================
// Verification Action
// ============================================================================

export const verificationActionValidator = v.union(
  v.literal('approved'),
  v.literal('rejected'),
  v.literal('changes_requested'),
  v.literal('reminder_sent'),
  v.literal('unapproved')
);

export type VerificationAction = Infer<typeof verificationActionValidator>;

export const VERIFICATION_ACTIONS = [
  'approved',
  'rejected',
  'changes_requested',
  'reminder_sent',
  'unapproved',
] as const;

// ============================================================================
// Verification Document Type
// ============================================================================

export const verificationDocumentTypeValidator = v.union(
  v.literal('approbation'),
  v.literal('insurance'),
  v.literal('both')
);

export type VerificationDocumentType = Infer<typeof verificationDocumentTypeValidator>;

export const VERIFICATION_DOCUMENT_TYPES = ['approbation', 'insurance', 'both'] as const;

// ============================================================================
// Kettendienst Status
// ============================================================================

export const kettendienstStatusValidator = v.union(
  v.literal('draft'),
  v.literal('active'),
  v.literal('partially_filled'),
  v.literal('completed'),
  v.literal('expired')
);

export type KettendienstStatus = Infer<typeof kettendienstStatusValidator>;

export const KETTENDIENST_STATUSES = [
  'draft',
  'active',
  'partially_filled',
  'completed',
  'expired',
] as const;

// ============================================================================
// Impersonation Session Status
// ============================================================================

export const impersonationSessionStatusValidator = v.union(
  v.literal('pending_approval'),
  v.literal('active'),
  v.literal('denied'),
  v.literal('ended')
);

export type ImpersonationSessionStatus = Infer<typeof impersonationSessionStatusValidator>;

export const IMPERSONATION_SESSION_STATUSES = [
  'pending_approval',
  'active',
  'denied',
  'ended',
] as const;

// ============================================================================
// Contact Inquiry Status
// ============================================================================

export const contactInquiryStatusValidator = v.union(
  v.literal('new'),
  v.literal('read'),
  v.literal('resolved')
);

export type ContactInquiryStatus = Infer<typeof contactInquiryStatusValidator>;

export const CONTACT_INQUIRY_STATUSES = ['new', 'read', 'resolved'] as const;

// ============================================================================
// Service Rating Rater Role
// ============================================================================

export const serviceRatingRaterRoleValidator = v.union(
  v.literal('provider'),
  v.literal('substitute')
);

export type ServiceRatingRaterRole = Infer<typeof serviceRatingRaterRoleValidator>;

export const SERVICE_RATING_RATER_ROLES = ['provider', 'substitute'] as const;
